import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { generateSliceCore, generateCoreExtraReducers } from "../core/tools";
import apiService from "../api/service";
// import dummyData from "../../database/blogs.json";
import adapter from "./adapter";
import * as config from "./config";
import { submissionStatus } from "../../constants";
const { NAME } = config;

const core = generateSliceCore(config);
const app = {
  initialState: {
    _payload: null,
    status: "idle",
    error: "",
    data: [],
    data_options: [],
    data_featured: [],
    data_by_status: []
  },
  action: {
    fetchBlogs: createAsyncThunk(`${NAME}/fetchBlogs`, async (options) => {
      const data = await apiService.get(NAME, options);
      return data;
    }),
    fetchFeaturedBlogs: createAsyncThunk(`${NAME}/fetchFeaturedBlogs`, async (options) => {
      const data = await apiService.get('blogs_featured', options);
      return data;
    }),
  },
};

/** Action - Thunks */
export const { setQuery, setCurrentPage, setSorter } = core.action;
export const { fetchBlogs, fetchFeaturedBlogs } = app.action;

/** Reducer - Extra Reducers */
const coreExtraReducers = generateCoreExtraReducers(core.action);

/** Slice */
export const blogsSlice = createSlice({
  name: NAME,
  initialState: {
    ...core.initialState,
    ...app.initialState,
  },
  reducers: {
    setStatus(state, action) {
      state.status = action.payload;
    },
    setPageItems(state, action) {
      state.pageItems = action.payload;
    },
  },
  extraReducers: {
    ...coreExtraReducers,

    // Blogs | Bulk
    [fetchBlogs.pending]: (state) => {
      state.status = "loading";
    },
    [fetchBlogs.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state._payload = action.payload;
      const {
        results,
        count,
        logSubmission
      } = action.payload

      const payload = adapter.responseBodyToRender(results);
      state.data = payload;
      state.pageItems = payload;
      state.data_options = adapter.responseBodyToOptions(
        results
      );
      state.totalItems = count;

      if(logSubmission){
        const logSubmissionKeys = Object.keys(logSubmission)
        const logSubmissions = logSubmissionKeys.map(k => {
          return {
            id: submissionStatus[k],
            label: k,
            value: logSubmission[k]
          }
        })

        state.data_by_status = logSubmissions;
      }
    },
    [fetchBlogs.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error.message;
    },

    [fetchFeaturedBlogs.fulfilled]: (state, action) => {
      state.data_featured_payload = action.payload;
      state.data_featured = adapter.responseBodyToRender(action.payload);
    }
  },
});

export const { setStatus, setPageItems } = blogsSlice.actions;
export const blogsActions = {
  ...blogsSlice.actions,
  ...core.action,
  ...app.action,
};
export default blogsSlice.reducer;
